import {connect} from 'react-redux';
import {ProtocolTask as Component} from './ProtocolTask';

import {
  saveTaskNote,
  setModal,
  showModal,
  spectrophotometerToggleInfoModal,
  setupComplete
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    pIndex: ownProps.pIndex,
    tIndex: ownProps.tIndex,
    level: ownProps.level,
    page: ownProps.page,
    task: state.notebook.protocolSection.scene.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].task,
    action: state.notebook.protocolSection.scene.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].action,
    notes: state.notebook.protocolSection.scene.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].notes,
    criteria: state.notebook.protocolSection.scene.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].criteria,
    complete: state.notebook.protocolSection.scene.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].complete,
    current: state.notebook.protocolSection.scene.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].current,
    aria: state.notebook.protocolSection.scene.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].aria,
    modal: state.notebook.protocolSection.scene.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].modal,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setupComplete: (data) => {
      dispatch(setupComplete(data))
    },
    spectrophotometerToggleInfoModal: (data) => {
      dispatch(spectrophotometerToggleInfoModal(data))
    },
    saveTaskNote: (data) => {
      dispatch(saveTaskNote(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const ProtocolTask = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
